export default "__VITE_ASSET__aB$Y4yyRLBAifs0yEgxESA__";